import { render, staticRenderFns } from "./LightingMgmt.vue?vue&type=template&id=3bc9aaad"
import script from "./LightingMgmt.vue?vue&type=script&lang=js"
export * from "./LightingMgmt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports